<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-sort:name>Название</th>
                        <th v-sort:unit colspan="2">Ед. измерения</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="component in components" :key="component.id">
                        <td class="truncate">{{ component.name }}</td>
                        <td>{{ component.unit | unit }}</td>

                        <td class="action-buttons">
                            <router-link :to="{ name: 'stocks.components.show', params: { id: component.id }}" class="btn btn-icon btn-edit" />
                            <button type="button" class="btn btn-icon btn-remove" @click.prevent="remove(component.id)" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="noOne" class="no-one">
                    <tr>
                        <td colspan="42">Вы пока не добавили ни одного ингредиента.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="noFound" class="no-one">
                    <tr>
                        <td colspan="42">По вашему запросу не найдено ни одного ингредиента.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="meta.last_page > 1">
                    <tr>
                        <td colspan="42">
                            <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                        </td>
                    </tr>
                </tfoot>
            </table>

            <router-view />
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'

import store from '@/store'
import { toastSuccess, toastError, confirm, getUsageMessage } from '@/dialogs'

export default {
    components: {
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({})
        }
    },

    computed: {
        components() {
            return this.$store.getters['components/data'] || []
        },

        meta() {
            return this.$store.getters['components/meta'] || {}
        },

        isMobile() {
            return this.$store.state.isMobile
        },

        noOne() {
            return this.components.length === 0 && !this.filter.search
        },

        noFound() {
            return this.components.length === 0 && this.filter.search
        }
    },

    methods: {
        async remove(id) {
            if (!await this.$store.dispatch('components/getUsage', id)) {
                return toastError('Ошибка')
            }

            if (!await confirm('Удалить?', getUsageMessage(this.$store.state.components.usage))) {
                return
            }

            const status = await this.$store.dispatch('components/remove', id)

            if (status) {
                toastSuccess('Удалено')
            } else {
                return toastError('Ошибка')
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('components/fetchAll', to.query)
        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await store.dispatch('components/fetchAll', to.query)
        next()
    }
}
</script>
